import { api } from "./api";


export const obtenerTodosLosLibros = async () => {
  const { data } = await api.get("/libros/all");
  return data;
};


export const obtenerLibroPorId = async (idLibro) => {
  try {
    const { data } = await api.get("/libros/findById", { params: { id: idLibro } });
    return data;
  } catch (error) {
    if (error.response?.status === 404) {
      throw new Error("Libro no encontrado🙁🤡");
    }
    throw new Error("Ha ocurrido un error al obtener el libro🙁🤡");
  }
};


export const crearLibroConAutoresYUbicacion = async (libroDto) => {
  const { data } = await api.post("/libros/crearLibro", libroDto);
  return data;
};

export const actualizarLibro = async (idLibro, libroDto) => {
  const { data } = await api.put(`/libros/actualizar/${idLibro}`, libroDto);
  return data;
};


export const deshabilitarLibro = async (idLibro) => {
  const { data } = await api.put(`/libros/deshabilitar/${idLibro}`, {});
  return data;
};


export const buscarLibros = (keyword) => {
  return api.get("/libros/buscar", { params: { query: keyword } });
};

export const buscarLibrosDTO = (keyword) => {
  return api.get("/libros/buscarDTO", { params: { query: keyword } });
};


export const obtenerLibrosPaginados = async (pageId, pageSize) => {
  const { data } = await api.get("/libros/allPaginados", {
    params: { page: pageId, size: pageSize },
  });
  return data;
};

export const obtenerLibrosSliders = async (idFondo, idCategoria, page = 0, size = 10) => {
  const { data } = await api.get("/libros/librosSliders", {
    params: { idFondo, idCategoria, page, size },
  });
  return data;
};

